









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {MascaraTransportadorSacPublico} from '@/model/resource/MascaraTransportadorSacPublico'
import {InputMascaraTransportadorSacPublicoSchema} from '@/schema/resource/MascaraTransportadorSacPublico/InputMascaraTransportadorSacPublicoSchema'

@Component
export default class PersistMascaraTransportadorSacPublicoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputMascaraTransportadorSacPublicoSchema()
  mascaraTransportadorSacPublico = new MascaraTransportadorSacPublico()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.mascaraTransportadorSacPublico.getMascaraTransportadorSacPublico(
        id
      )
    }

    $.await.done('getMascaraTransportadorSacPublico')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.mascaraTransportadorSacPublico.persistMascaraTransportadorSacPublico()
    await Helper.successAndPush(
      'system.success.persist',
      '/mascara-transportador-sac-publico/list'
    )
  }
}
